export const HELP_MANUAL_LINK =
  'https://docs.google.com/presentation/d/e/2PACX-1vRYUx6BW2mduyP7BmWkLRfppx1ioWmoOy3XoL75M7MDCI-yox047voyI7dIRYWopaLm_u3qhVdlsKm_/pub?start=false&loop=false&delayms=60000&slide=id.g2d53e5ff614_0_866';
const REQUEST_RECEIPT_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLScpi7r_HdHjxy-SsLKYfy5hLozYnTICalj3KgRo1kah62rYAw/viewform?usp=pp_url&entry.419782953={company}&entry.2081299747={cuit}&entry.874853357={date}';
//TODO: Replace link for prod deploy
//'https://docs.google.com/forms/d/e/1FAIpQLSejk-jh_GMlQaHRnbksTEnWbF4PbAvMLFpyLahz10I5SU_2vQ/viewform?usp=pp_url&entry.419782953={company}&entry.2081299747={cuit}&entry.874853357={date}';

/**
 * Add company name and cuil to form link
 * @param company
 * @param cuit
 */
export const getRequestLink = (company: string, cuit: string) =>
  REQUEST_RECEIPT_LINK.replace('{company}', company)
    .replace('{cuit}', cuit)
    .replace('{date}', new Date().toISOString().split('T')[0]);
